<template>
    
    <div class="media-column-layout">

        <!-- 1 Column (Large) -->
        <!-- 1 Column (Default) -->
        <!-- 2 Column -->
        <!-- 3 Column-->
        <div 
            ref="columns"
            class="columns" 
            :class="this.data.layout"
            :style="{backgroundColor: backgroundColor}"
        >
            <Column 
                ref="columnComponents"
                v-for="(column, index) in this.data.columns"
                :key="index"
                :data="column"
                :style="{boxShadow: boxShadow}"
                @loaded="onColumnLoaded"
            >
            </Column>
        </div>
        
    </div>
    
</template>


<script>
import Column from '@/components/MediaColumn'
import Observer from '@/plugins/Observer'

export default {
    
    props: {
        data: {
            type: Object,
            required: true,
            // default: () => {},
        }
    },
    
    components: {
        Column
    },
    
    data() {
        return {
            backgroundColor: '',
            boxShadow: 'none',
        }
    },
    
    created() {
        this.backgroundColor = this.data.backgroundColor
    },
    
    destroyed() {
        this.observer.destroy()
    },
    
    mounted() {
        this.observer = new Observer(this.$refs.columns, this.onEnter, this.onLeave)
    },
    
    methods: {
        
        onEnter() {
            for (var i = 0; i < this.$refs.columnComponents.length; i++) {
                this.$refs.columnComponents[i].onEnter()
            }
        },
        
        onLeave() {
            for (var i = 0; i < this.$refs.columnComponents.length; i++) {
                this.$refs.columnComponents[i].onLeave()
            }
        },
        
        onColumnLoaded() {
            
            // Set box-shadow - https://tobiasahlin.com/blog/layered-smooth-box-shadows/
            // this.boxShadow = (this.data.shadowStrength > 0) ? '0px 0px 1vw 0px rgba(0,0,0,' + this.data.shadowStrength + ')' : 'none'
                
            this.boxShadow = (this.data.shadowStrength > 0) ? '0 1px 1px rgba(0,0,0,' + this.data.shadowStrength + '), 0 2px 2px rgba(0,0,0,' + this.data.shadowStrength + '), 0 4px 4px rgba(0,0,0,' + this.data.shadowStrength + '), 0 8px 8px rgba(0,0,0,' + this.data.shadowStrength + '), 0 16px 16px rgba(0,0,0,' + this.data.shadowStrength + ')' : 'none'
        },
    },
    
}

</script>


<style lang="scss" scoped>
@import '../scss/variables';


.media-column-layout {
    
    .columns {
        padding-top: 6%;
        padding-bottom: 6%;
        
        @media (min-width: $tablet) {
            padding-top: 10%;
            padding-bottom: 10%;
            display: flex;
            justify-content: center;
        }
        
        .column {
            margin: 6%;
            
            &:first-child {
                margin-top: 0;
            }
            &:last-child {
                margin-bottom: 0;
            }
            
            @media (min-width: $tablet) {
                margin: inherit;
            }
        }
        
        
        @media (min-width: $tablet) {
            &.col-1-large {
                .column {
                    width: calc(14 / 24 * 100%); // 14 / 24 columns 
                }
            }
            
            &.col-1 {
                .column {
                    width: calc(8 / 24 * 100%); // 8 / 24 columns     
                }
            }
            
            &.col-2 {
                .column {
                    width: calc(8 / 24 * 100%); // 8 / 24 columns 
                    display: inline-block;
                    vertical-align: top;
                    
                    &:first-child {
                        margin-right: 1.5%;
                    }
                    &:last-child {
                        margin-left: 1.5%;
                    }
                }
            }
            
            &.col-3 {
                .column {
                    width: calc(6 / 24 * 100%); // 6 / 24 columns 
                    display: inline-block;
                    vertical-align: top;
                    
                    &:nth-child(2) {
                        margin-left: 3%;
                        margin-right: 3%;
                    }
                }
            }
        }
    }
}
</style>
